import { PaginatedResponse } from '@gorila-shared-ui/components';
import { atom, selector, selectorFamily } from 'recoil';
import { SubAccount, SubAccountCore } from '../types/subAccount';
import { apiParamsState } from './app';

export const loadingSubAccountsState = atom({
  key: 'app.subAccounts.loading',
  default: false,
});

export const allSubAccountsState = atom<SubAccount[] | undefined>({
  key: 'app.subAccounts.all',
  default: undefined,
});

export const subAccountsState = atom<PaginatedResponse<SubAccount> | undefined>({
  key: 'app.subAccounts',
  default: undefined,
});

export const searchSubAccountState = atom<string | undefined>({
  key: 'app.subAccounts.search',
  default: undefined,
});

export const subAccountsPageState = atom({
  key: 'app.subAccounts.page',
  default: 1,
});

export const subAccountIdsState = selector<string[] | undefined>({
  key: 'app.subAccountIds',
  get: ({ get }) => {
    const subAccounts = get(subAccountsState);
    if (!subAccounts) return;
    return subAccounts.items.map((subAccount) => subAccount._id);
  },
});

export const subAccountState = selectorFamily<SubAccount | undefined, string>({
  key: 'app.subAccount',
  get:
    (id) =>
    ({ get }) => {
      const subAccounts = get(subAccountsState);
      if (!subAccounts) return;
      return subAccounts.items.find((subAccount) => subAccount._id === id);
    },
});

export const selectedSubAccountIdState = atom<string | undefined>({
  key: 'app.subAccounts.selected',
  default: undefined,
});

export const editingSubAccountState = atom<SubAccountCore | undefined>({
  key: 'app.subAccounts.editing',
  default: selector({
    key: 'app.subAccounts.editing.initializer',
    get: ({ get }) => {
      const selectedSubAccountId = get(selectedSubAccountIdState);
      if (selectedSubAccountId === undefined) return;
      if (selectedSubAccountId === '') {
        const apiParams = get(apiParamsState);
        if (!apiParams) return;
        return {
          _id: '',
          name: '',
          assets: [],
          client: {
            _id: apiParams.clientId,
            name: '',
          },
          subClient: {
            _id: apiParams.subClientId,
            name: '',
          },
        };
      }
      return get(subAccountState(selectedSubAccountId));
    },
  }),
});

export const updateSubAccountsState = atom<string | undefined>({
  key: 'app.subAccounts.update',
  default: undefined,
});
